import { Stack, StackProps } from '@chakra-ui/react'
import React from 'react'

export const InfoBox: React.FC<StackProps> = props => (
  <Stack
    py={4}
    px={[3, 6]}
    borderRadius={28}
    border="2px solid"
    borderColor="green.500"
    fontFamily="hero-new"
    background="white"
    _dark={{ bg: 'gray.900', borderColor: 'green.600' }}
    fontWeight={300}
    width="auto"
    spacing={4}
    {...props}
  />
)
